import { FC, FormEventHandler } from 'react';
import { Flex, VStack } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import {
  CardCvcInput,
  CardExpiryInput,
  CardNumberInput,
} from 'features/Stripe';

import locales from './locales';
import { CardCvcInputWrapper, CardExpiryDateWrapper } from './styles';

interface FormProps {
  disabled: boolean;
  loading: boolean;
  price: number;
  onSubmit: FormEventHandler<HTMLDivElement>;
}

const Form: FC<FormProps> = ({ disabled, loading, onSubmit, price }) => (
  <VStack alignItems="strech" as="form" onSubmit={onSubmit} spacing="space-24">
    <CardNumberInput disabled={disabled} />

    <Flex flexDirection="row">
      <CardExpiryDateWrapper>
        <CardExpiryInput disabled={disabled} />
      </CardExpiryDateWrapper>
      <CardCvcInputWrapper>
        <CardCvcInput disabled={disabled} />
      </CardCvcInputWrapper>
    </Flex>

    <Button
      alignSelf="start"
      isDisabled={disabled}
      isExpanded
      isLoading={loading}
      type="submit"
    >
      {locales.formatString(locales.submitButton, {
        amount: formatAmount({
          currency: 'EUR',
          forcePlusSign: false,
          value: price,
          withNoMinorUnitDigits: false,
        }),
      })}
    </Button>
  </VStack>
);

export default Form;
